import type { ReactNode } from 'react'
import { useOnline } from '@hooks/useOnline.ts'
import styles from './OnlineFieldset.module.css'

type Props = {
	className?: string | undefined
	children: ReactNode
}

// A <fieldset> that disables every control inside it while offline, so a
// whole editable section goes read-only at once. Links stay live.
export const OnlineFieldset = ({ className, children }: Props) => {
	const online = useOnline()
	return (
		<fieldset
			disabled={!online}
			className={`${styles.fieldset} ${className ?? ''}`.trim()}
		>
			{children}
		</fieldset>
	)
}
